import React, { createRef, useEffect } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import LayersFront from '@cover/stillestoppen/stillestoppenfront';
import LayersBack from '@cover/stillestoppen/stillestoppenback';

const TypoBack = styled(LayersBack)`
	position: absolute;
	z-index: 333;
`
const TypoFront = styled(LayersFront)`
	position: absolute;
	z-index: 999;
`

const StilleStoppen = ({ play }) => {
	const typoBack = createRef();
	const typoFront = createRef();

	useEffect(() => {
		// typo back
		const spueren = typoBack.current.querySelector('#spueren')
		const spuerenS = typoBack.current.querySelector('#stillestoppen_svg__spueren-s')
		const spuerenP = typoBack.current.querySelector('#stillestoppen_svg__spueren-p')
		const spuerenU = typoBack.current.querySelector('#stillestoppen_svg__spueren-u')
		const spuerenDotLeft = typoBack.current.querySelector('#stillestoppen_svg__spueren-dot-left')
		const spuerenDotRight = typoBack.current.querySelector('#stillestoppen_svg__spueren-dot-right')
		const spuerenR = typoBack.current.querySelector('#stillestoppen_svg__spueren-r')
		const spuerenE = typoBack.current.querySelector('#stillestoppen_svg__spueren-e')
		const spuerenN = typoBack.current.querySelector('#stillestoppen_svg__spueren-n')

		// typo front
		const hoeren = typoFront.current.querySelector('#hoeren')
		const hoerenH = typoFront.current.querySelector('#stillestoppen_svg__hoeren-h')
		const hoerenO = typoFront.current.querySelector('#stillestoppen_svg__hoeren-o')
		const hoerenDotLeft = typoFront.current.querySelector('#stillestoppen_svg__hoeren-dot-left')
		const hoerenDotRight = typoFront.current.querySelector('#stillestoppen_svg__hoeren-dot-right')
		const hoerenR = typoFront.current.querySelector('#stillestoppen_svg__hoeren-r')
		const hoerenE = typoFront.current.querySelector('#stillestoppen_svg__hoeren-e')
		const hoerenN = typoFront.current.querySelector('#stillestoppen_svg__hoeren-n')

		// &
		const and = typoFront.current.querySelector('#stillestoppen_svg__and-symbol')

		// dots
		const dotTopLeft = typoFront.current.querySelector('#stillestoppen_svg__dot-top-left')
		const dotBottomRight = typoFront.current.querySelector('#stillestoppen_svg__dot-bottom-right')
		const dotTopRight = typoFront.current.querySelector('#stillestoppen_svg__dot-top-right')
		const dots = [dotTopRight, dotTopLeft, dotBottomRight]

		const all = [spuerenS, spuerenP, spuerenU, spuerenDotLeft, spuerenDotRight, spuerenR, spuerenE, spuerenN, dotTopRight, dotTopLeft, and, dotBottomRight, hoerenH, hoerenO, hoerenDotLeft, hoerenDotRight, hoerenR, hoerenE, hoerenN]


		const timeline = anime.timeline({
			autoplay: play,
			loop: true
		});

		timeline
		.add({
			targets: [spuerenS, spuerenP, spuerenU, spuerenDotLeft, spuerenDotRight, spuerenR, spuerenE, spuerenN],
			duration: 400,
			easing: 'easeInOutSine',
			delay: anime.stagger(100, {start: 500}),
			opacity: 1
		})
		.add({
			targets: and,
			duration: 400,
			easing: 'easeInOutSine',
			delay: 50,
			opacity: 1
		})
		.add({
			targets: [hoerenH, hoerenO, hoerenDotLeft, hoerenDotRight, hoerenR, hoerenE, hoerenN],
			duration: 400,
			easing: 'easeInOutSine',
			delay: anime.stagger(100, {start: 500}),
			opacity: 1
		})
		.add({
			targets: dots,
			easing: 'easeInOutSine',
			opacity: 1,
			duration: 1000,
			delay: anime.stagger(200, {start: 1000}),
		})
		.add({
			targets: dotTopLeft,
			easing: 'easeInOutSine',
			keyframes: [
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1200},
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1200},
				{opacity: 1, duration: 1200}
			]
		}, '-=3000')
		.add({
			targets: dotTopRight,
			easing: 'easeInOutSine',
			keyframes: [
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1200},
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1200},
				{opacity: 1, duration: 1200}
			]
		}, '-=5500')
		.add({
			targets: dotBottomRight,
			easing: 'easeInOutSine',
			keyframes: [
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1000},
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1000},
				{opacity: 1, duration: 1000}
			]
		}, '-=5500')
		.add({
			targets: spuerenDotLeft,
			easing: 'easeInOutSine',
			keyframes: [
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1200},
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1200},
				{opacity: 1, duration: 1200}
			]
		}, '-=7000')
		.add({
			targets: hoerenDotLeft,
			easing: 'easeInOutSine',
			keyframes: [
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1200},
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1200},
				{opacity: 1, duration: 1200}
			]
		}, '-=6500')
		.add({
			targets: spuerenDotRight,
			easing: 'easeInOutSine',
			keyframes: [
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1200},
				{opacity: 1, duration: 1200},
			]
		}, '-=6300')
		.add({
			targets: hoerenDotRight,
			easing: 'easeInOutSine',
			keyframes: [
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1200},
				{opacity: 1, duration: 1200},
				{opacity: 0, duration: 1200},
				{opacity: 1, duration: 1200}
			]
		}, '-=7000')
		.add({
			targets: [dots, spueren, and, hoeren],
			duration: 800,
			delay: anime.stagger(100, {start: 500}),
			easing: 'easeInOutSine',
			opacity: 0
		}, '-=700')
	}, [play])
	return (
		<>
			<TypoBack ref={typoBack}/>
			<TypoFront ref={typoFront}/>
		</>
	)
};

export default StilleStoppen;